import React, { useEffect, createElement } from 'react';
import { motion } from 'framer-motion';
import { Download, Eye, GraduationCap, Award, CheckCircle2 } from 'lucide-react';
const competencies = ['Executive Leadership', 'Healthcare Policy', 'Board Governance', 'Strategic Planning', 'Government Relations', 'Financial Oversight', 'Healthcare Operations', 'Business Development', 'Advocacy Leadership'];
export function Credentials() {
  useEffect(() => {
    document.title = 'Resume & Credentials | Michelle McOmber Healthcare Executive';
  }, []);
  const handleDownload = () => {
    const blob = new Blob(['Michelle McOmber — Executive Resume\n\nPlaceholder resume. Replace with the actual PDF.'], {
      type: 'text/plain'
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'Michelle-McOmber-Resume.txt';
    a.click();
    URL.revokeObjectURL(url);
  };
  return <div className="w-full bg-slate-50 min-h-screen" data-id="element-238">
      <header className="bg-navy-900 text-white py-20" data-id="element-239">
        <div className="max-w-7xl mx-auto px-6" data-id="element-240">
          <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-6" data-id="element-241">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6
          }} data-id="element-242">
              <h1 className="text-4xl md:text-5xl font-serif font-bold mb-4 text-white" data-id="element-243">
                Resume &amp; Credentials
              </h1>
              <p className="text-xl text-slate-300 max-w-2xl" data-id="element-244">
                Education, certifications, and executive competencies.
              </p>
            </motion.div>
            <div className="flex flex-col sm:flex-row gap-3 shrink-0" data-id="element-245">
              <a href="https://heyzine.com/flip-book/952e7ede0c.html" target="_blank" rel="noopener noreferrer" className="bg-gold hover:bg-gold-600 text-white px-6 py-4 font-medium transition-colors flex items-center justify-center" data-id="element-246">
                <Eye className="w-5 h-5 mr-2" data-id="element-247" />
                View Resume
              </a>
              <button onClick={handleDownload} className="bg-white/10 hover:bg-white/20 border border-white/30 text-white px-6 py-4 font-medium transition-colors flex items-center justify-center" data-id="element-248">
                <Download className="w-5 h-5 mr-2" data-id="element-249" />
                Download Resume
              </button>
            </div>
          </div>
        </div>
      </header>

      <section className="py-20" data-id="element-250">
        <div className="max-w-7xl mx-auto px-6" data-id="element-251">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16" data-id="element-252">
            <div className="space-y-12" data-id="element-253">
              <div data-id="element-254">
                <div className="flex items-center mb-8" data-id="element-255">
                  <GraduationCap className="w-8 h-8 text-gold mr-4" data-id="element-256" />
                  <h2 className="text-3xl font-serif font-bold text-navy-900" data-id="element-257">
                    Education
                  </h2>
                </div>
                <div className="space-y-8" data-id="element-258">
                  <div className="bg-white p-8 rounded-xl shadow-sm border border-slate-100" data-id="element-259">
                    <h3 className="text-xl font-bold text-navy-900 mb-1" data-id="element-260">
                      Master of Business Administration (MBA)
                    </h3>
                    <p className="text-gold font-medium mb-4" data-id="element-261">
                      Summa Cum Laude
                    </p>
                    <p className="text-slate-600" data-id="element-262">Westminster College</p>
                  </div>
                  <div className="bg-white p-8 rounded-xl shadow-sm border border-slate-100" data-id="element-263">
                    <h3 className="text-xl font-bold text-navy-900 mb-1" data-id="element-264">
                      Bachelor&rsquo;s Degree
                    </h3>
                    <p className="text-slate-600" data-id="element-265">University of Utah</p>
                  </div>
                </div>
              </div>

              <div data-id="element-266">
                <div className="flex items-center mb-8" data-id="element-267">
                  <Award className="w-8 h-8 text-gold mr-4" data-id="element-268" />
                  <h2 className="text-3xl font-serif font-bold text-navy-900" data-id="element-269">
                    Certifications
                  </h2>
                </div>
                <div className="bg-white p-8 rounded-xl shadow-sm border border-slate-100" data-id="element-270">
                  <h3 className="text-xl font-bold text-navy-900 mb-2" data-id="element-271">
                    Certified Association Executive (CAE)
                  </h3>
                  <p className="text-slate-600" data-id="element-272">
                    The premier credential for association leadership,
                    demonstrating mastery of governance, strategy, and
                    operations.
                  </p>
                </div>
              </div>
            </div>

            <div data-id="element-273">
              <div className="bg-navy-900 text-white p-10 rounded-xl" data-id="element-274">
                <h2 className="text-3xl font-serif font-bold mb-8 text-white" data-id="element-275">
                  Executive Competencies
                </h2>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-276">
                  {competencies.map(c => <div key={c} className="flex items-center" data-id="element-277">
                      <CheckCircle2 className="w-5 h-5 text-gold mr-3 shrink-0" data-id="element-278" />
                      <span className="font-medium" data-id="element-279">{c}</span>
                    </div>)}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>;
}